module.exports = __webpack_public_path__ + "img/formulaEle.3a4577c6.svg";